module.exports = __webpack_public_path__ + "img/guideSix.d2fe2701.png";